import styled from 'styled-components';
import { device } from '../../styles/devices';
import { SIZING } from '../../styles/variables';

export const MileageInfoContainer = styled.div<{ isT3?: boolean }>`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: flex-end;
  /* margin-bottom: 35px; */
  /* margin-top: ${({ isT3 }) => (isT3 ? SIZING.unit(4.5) : '')}; */
  margin-top: ${({ isT3 }) => (isT3 ? SIZING.unit(4) : '')};
  @media ${device.tablet} {
    display: flex;
    margin-bottom: 0px;
    /* padding-top: 70px; */
    padding-top: 32px;
    margin-top: ${({ isT3 }) => (isT3 ? 'unset' : '')};
  }
  @media ${device.laptopM} {
    align-items: flex-start;
    flex-direction: column;
    padding-top: 0px;
  }
`;

export const Warranty = styled.h3`
  .regular {
    font-weight: normal;
  }
  .italics {
    font-style: italic;
  }
  font-family: 'Audi Type Extended';
  font-size: 10px;
  font-weight: bold;
  line-height: 18px;
  @media ${device.tablet} {
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
    letter-spacing: -0.3px;
  }
`;
